import { colors } from 'shared'

export const LKGridConfig = {
  gridIdentity: { formName: 'frm_account_view', objectName: 'dbgrd_perm' },
  syncGridState: true,
  enableRowSelection: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableColumnsHide: true,

  columnConfigs: {
    AccessFind: {
      iconComponent: (value) => (value === 0 ? 'cancel' : 'ok'),
      isDisplayHeader: true,
    },
    AccessUse: {
      iconComponent: (value) => (value === 0 ? 'cancel' : 'ok'),
      isDisplayHeader: true,
    },
    AccessView: {
      iconComponent: (value) => (value === 0 ? 'cancel' : 'ok'),
      isDisplayHeader: true,
    },
  },

  getRowStyle: ({
    node: {
      data: { AGen },
    },
  }) => {
    if (AGen !== 0) {
      return { color: colors.grey }
    }

    return {}
  },
}
